var RELATIONSHIP_NONE = 'NONE';
var RELATIONSHIP_JOINED = 'JOINED';
var RELATIONSHIP_PENDING_APPROVAL = 'PENDING_APPROVAL';

module.exports = {
  RELATIONSHIP_NONE,
  RELATIONSHIP_JOINED,
  RELATIONSHIP_PENDING_APPROVAL
}
